import { createSlice, createEntityAdapter } from '@reduxjs/toolkit';

import { Wall, WallWindowRelations } from 'types';

const wallsAdapter = createEntityAdapter<Wall | WallWindowRelations>({
  sortComparer: (a, b) => a.name.localeCompare(b.name),
});

interface ExtraInitialState {
  selectedWallId: number;
  inSingleTraceView: boolean;
}

export const wallsSlice = createSlice({
  name: 'walls',
  initialState: wallsAdapter.getInitialState({
    selectedWallId: -1,
    inSingleTraceView: false,
  } as ExtraInitialState),
  reducers: {
    selectedWallChanged: (state, { payload }) => {
      state.selectedWallId = payload;
    },
    toggleSingleTraceView: (state, { payload }) => {
      state.inSingleTraceView = payload;
    },
  },
});

export const { selectedWallChanged, toggleSingleTraceView } =
  wallsSlice.actions;

export default wallsSlice.reducer;
